<template lang="pug">
.form-group(:class="{ 'label-floating' : labelFloating }").custom-form-group
  label.control-label(v-if='label')
    | {{label}}
    span(v-if='count' style='float:right;') {{countCharacter}}/ {{totalCharacter}} kí tự
    span(v-if='checkbox' style='float:right;')
      table
        tr
          td
            input(type='checkbox' @click="getCheckbox" :checked="isChecked ? true : false")
          td Hiển thị với mọi người
  textarea.form-control(v-bind='$props', @input="$emit('input',$event.target.value)" , v-if="type === 'textarea'")
  input.form-control(v-bind='$props', :value='value', @input="$emit('input',$event.target.value)", v-else)
</template>
<script>
export default {
  name: 'md-fg-input',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    name: String,
    disabled: Boolean,
    required: Boolean,
    placeholder: String,
    value: [String, Number],
    labelFloating: Boolean,
    rows: Number,
    cols: Number,
    autocomplete: {
      type: String,
      default: 'off'
    },
    count: Boolean,
    countCharacter: {
      type: Number,
      default: 0
    },
    totalCharacter: {
      type: Number,
      default: 160
    },
    maxlength: String,
    checkbox: Boolean,
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getCheckbox(e) {
      // console.log(this.name, e.target.checked)
      this.$emit('getCheckBox', [this.name, e.target.checked])
    }
  }
}

</script>
<style lang="scss">
.custom-form-group {
  margin: 0;
}
input[type="color"] {
  &.form-control {
    height: 36px;
    padding: 0 !important;
    border: none;
    border-radius: 20px;
    overflow: hidden;
  }
}
input[type="checkbox"] {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// index.vue?2166f3c4